import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M4.01 2L4 22h16V8l-6-6H4.01zM13 9V3.5L18.5 9H13z"
}), 'InsertDriveFileSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/InsertDriveFileSharp.js
// module id = 4272
// module chunks = 2